import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { MultiMenuTrigger } from '@protonapp/react-multi-menu'
import { useFlags } from 'launchdarkly-react-client-sdk'

// components
import Icon, { IconButton } from 'components/Shared/Icon'

// ducks
import { getApp } from 'ducks/apps'
import {
  createTable,
  getDatasources,
  removeTable,
  updateTable,
} from 'ducks/apps/datasources'
import { loadMetrics, getMetrics } from 'ducks/metrics'

// dependent components
import Items from './Items'

// custom styles
import './Panel.scss'

const DataPanel = props => {
  const {
    createTable,
    datasources,
    loadMetrics,
    history,
    match,
    metrics,
    removeTable,
    updateTable,
  } = props

  const { appId } = match.params

  const datasource = datasources.length === 1 && datasources[0]
  const datasourceId = datasource && datasource.id

  const { collectionPermissionsPhase2 } = useFlags()

  useEffect(() => {
    if (datasourceId) {
      loadMetrics(appId, datasourceId)
    }
  }, [datasourceId])

  const handleCollectionPermissionsClicked = () => {
    return history.push(`/apps/${appId}/data/${datasourceId}/permissions`)
  }

  return (
    <div className="app-data-panel">
      <h2 className="left-panel-title">
        <Icon type="data" /> <span className="title">Database Collections</span>
        {collectionPermissionsPhase2 && (
          <CollectionsMenu
            onPermissionsClick={handleCollectionPermissionsClicked}
          />
        )}
      </h2>

      <Items
        appId={appId}
        datasources={datasources}
        datasourceId={datasourceId}
        metrics={metrics}
        createTable={createTable}
        removeTable={removeTable}
        updateTable={updateTable}
      />
    </div>
  )
}

const CollectionsMenu = ({ onPermissionsClick }) => {
  const options = [
    {
      label: (
        <div className="collections-menu-permissions">
          <Icon type="security-badge" /> <p>Permissions</p>
        </div>
      ),
      onClick: onPermissionsClick,
    },
  ]

  return (
    <MultiMenuTrigger menu={options} rowHeight={40} width={180}>
      <IconButton type="more-vert" />
    </MultiMenuTrigger>
  )
}

const mapStateToProps = (state, { match }) => {
  const { appId } = match.params

  return {
    app: getApp(state, appId),
    datasources: getDatasources(state, appId),
    metrics: getMetrics(state, appId),
  }
}

const mapDispatchToProps = {
  createTable,
  loadMetrics,
  removeTable,
  updateTable,
}

const connected = connect(mapStateToProps, mapDispatchToProps)(DataPanel)

export default withRouter(connected)
